/**
 * @generated SignedSource<<7c455186f36ccd7e4ba4a86dd5eb71f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type spacePaywall_space$data = {
  readonly id: string;
  readonly primaryProduct: {
    readonly accessDefaultDuration: number | null | undefined;
    readonly accessGroup: {
      readonly accessGroup: {
        readonly courses: ReadonlyArray<{
          readonly course: {
            readonly name: string;
          };
          readonly id: string;
        }>;
        readonly spaces: ReadonlyArray<{
          readonly id: string;
          readonly name: string;
        }>;
      };
    };
    readonly basePrice: string | null | undefined;
    readonly checkoutUrl: string | null | undefined;
    readonly description: any | null | undefined;
    readonly id: string;
    readonly productName: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "spacePaywall_space";
};
export type spacePaywall_space$key = {
  readonly " $data"?: spacePaywall_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"spacePaywall_space">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "spacePaywall_space",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "PaymentIntegrationProduct",
      "kind": "LinkedField",
      "name": "primaryProduct",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accessDefaultDuration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkoutUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "basePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ExternalProductAccessGroup",
          "kind": "LinkedField",
          "name": "accessGroup",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "AccessGroup",
              "kind": "LinkedField",
              "name": "accessGroup",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AccessGroupCourse",
                  "kind": "LinkedField",
                  "name": "courses",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Course",
                      "kind": "LinkedField",
                      "name": "course",
                      "plural": false,
                      "selections": [
                        (v1/*: any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "spaces",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Space",
  "abstractKey": "__isSpace"
};
})();

(node as any).hash = "dac47208050396d00900bacbb8b9bd47";

export default node;
